module.exports = __webpack_public_path__ + "static/img/guanyuwomen.8053309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guanyuwomen.png
// module id = PQuX
// module chunks = 26